import React from "react";
import TabBar from "../../TabBar";
import { observer } from "mobx-react/index";

@observer
class EventHome extends React.Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default EventHome;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Event/EventHome.js